import { render, staticRenderFns } from "./DeliveryPoints.vue?vue&type=template&id=a0769368&scoped=true&"
import script from "./DeliveryPoints.vue?vue&type=script&lang=js&"
export * from "./DeliveryPoints.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=a0769368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0769368",
  null
  
)

export default component.exports